// src/components/ScrollAnimate.js
import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';

export const fadeInUp = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
};

export const fadeInLeft = {
  hidden: { opacity: 0, x: -50 },
  visible: { opacity: 1, x: 0, transition: { duration: 0.7, ease: "easeOut" } },
};

export const fadeInRight = {
  hidden: { opacity: 0, x: 50 },
  visible: { opacity: 1, x: 0, transition: { duration: 0.7, ease: "easeOut" } },
};

export const scaleUp = {
  hidden: { opacity: 0, scale: 0.8 },
  visible: { opacity: 1, scale: 1, transition: { duration: 0.5, ease: "easeOut" } },
};

export const staggerContainer = (staggerChildren = 0.1, delayChildren = 0) => ({
  hidden: {}, // Container itself doesn't animate opacity/y unless specified
  visible: {
    transition: {
      staggerChildren,
      delayChildren,
    },
  },
});

const ScrollAnimate = ({
  children,
  className,
  variants = fadeInUp, // Default to fadeInUp
  once = true,
  amount = 0.2, // Trigger when 20% of the element is in view
  tag = 'div', // Allow specifying the HTML tag
  ...rest
}) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once, amount });
  const MotionComponent = motion[tag];

  return (
    <MotionComponent
      ref={ref}
      className={className}
      initial="hidden"
      animate={isInView ? "visible" : "hidden"}
      variants={variants}
      {...rest}
    >
      {children}
    </MotionComponent>
  );
};

export default ScrollAnimate;